module.exports = __webpack_public_path__ + "media/images/application/template/sharmans-966ce67931615f8cb2589c7f8b8e71ae.svg";